import { L } from '@lib';
import { OrderStatus } from '@models';
import { useStore } from '@stores';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { NotifyChannelsSelect, defaultNotifyChannels } from '../Select/NotifyChannelsSelect';

const { Text } = Typography;

/**
 * "Send for approval" for a Draft estimate: once the extra check is done, the draft becomes an
 * Estimate and the customer is told - through whichever channels are picked here, straight away.
 * Only offered while the saved status is Draft. The estimate is made from the services as they are
 * saved, so unsaved edits are not in it.
 */
export const SendForApprovalButton = observer(({ block }: { block?: boolean }) => {
  const { orderStore } = useStore();
  const { order } = orderStore;
  const [open, setOpen] = useState(false);
  const [channels, setChannels] = useState<string[]>([]);
  const [sending, setSending] = useState(false);

  if (!order || (orderStore.savedStatus ?? order.status) !== OrderStatus.Draft) return null;

  const openModal = () => {
    setChannels(defaultNotifyChannels(order.customer));
    setOpen(true);
  };

  const send = async () => {
    setSending(true);
    try {
      if (await orderStore.sendForApproval(channels)) setOpen(false);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Button type="primary" block={block} style={{ minWidth: 100 }} onClick={openModal}>
        {L('Send estimate')}
      </Button>
      <Modal
        open={open}
        title={L('Send estimate to the customer')}
        okText={L('Send estimate')}
        confirmLoading={sending}
        onOk={send}
        onCancel={() => setOpen(false)}
        destroyOnClose
      >
        <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
          {L(
            'The draft becomes an estimate and the customer is asked to approve it. It is sent as it is saved - save any changes first.'
          )}
        </Text>
        <Text strong style={{ display: 'block', marginBottom: 4 }}>
          {L('Send estimate by')}
        </Text>
        <NotifyChannelsSelect customer={order.customer} value={channels} onChange={setChannels} />
      </Modal>
    </>
  );
});
